import { useState } from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import Header from '../header/Header'
import Sidebar from '../sidebar/Sidebar';
import SessionManager from '../../utils/sessionManager';
import Swal from 'sweetalert2';
import colors from '../../theme/colors';
import { Grid } from 'antd';
const { useBreakpoint } = Grid;

const useAuth = () => {
    let user = SessionManager.getCookie("user_token");

    if (user) {
        try {
            if (user) {
                return user;
            }
        } catch (error) {
            return false
        }
    } else {
        return false
    }
}

const Auth = (props) => {
    const [collapsed, setCollapsed] = useState(false)
    const [drawerOpen, setDrawerOpen] = useState(false)
    const auth = useAuth()
    const navigate = useNavigate()
    const location = useLocation()

    const screens = useBreakpoint();
    const isMobileOrTablet = !screens.lg; // < 992px → treat as mobile

    var permission = JSON.parse(SessionManager.getSession('permission'))

    const isRouteAuthorized = permission && permission.some(
        (item) => item.route === location.pathname
    );

    if (!auth) {
        return <Navigate to="/login" />
    }
    else if (!isRouteAuthorized) {
        if (auth && location.pathname == '/') {
            return <Navigate to="/dashboard" />
        } else {
            Swal.fire({
                title: 'Access Denied',
                text: "You do not have permission to access this page. Please contact your Administrator to request access.",
                icon: 'error',
                showCancelButton: false,
                confirmButtonColor: colors.primary,
                cancelButtonColor: '#EF3D50',
                confirmButtonText: 'Ok'
            }).then((result) => {
                if (result.isConfirmed) {
                    navigate(-1)
                }
            })
            return null;
        }
    }
    else {
        return (
            <div>
                <Header collapsed={collapsed} setCollapsed={setCollapsed} drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} isMobileOrTablet={isMobileOrTablet} />
                <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} isMobileOrTablet={isMobileOrTablet} />
                <div className={isMobileOrTablet ? 'outlet_mobile_view' : collapsed ? "outlet_collapsed" : "outlet_not_collapsed"}>
                    <Outlet />
                </div>
            </div>
        )
    }
}

export default Auth;